import classes from "./ellipsis.module.css"

const Ellipsis = () => {
  return <div className={classes.root}>...</div>
}

export default Ellipsis
